import type { ListBuilderConfiguration } from '../../types';
import { allVehiclesList } from './lists/all-vehicles';
import { availableVehiclesList } from './lists/available';
import { onRouteVehiclesList } from './lists/on-route';
import { unavailableVehiclesList } from './lists/unavailable';

/**
 * Vehicle list configuration
 * Multi-view list with 4 tabs: All, On Route, Available, Maintenance/Inactive
 */
export const VEHICLE_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [
		allVehiclesList,
		onRouteVehiclesList,
		availableVehiclesList,
		unavailableVehiclesList,
	],
	paging: {
		defaultPageSize: 20,
		pageSizeOptions: [10, 20, 50, 100],
	},
	filters: {
		activeFilters: ['vehicleSearch', 'vehicleStatus', 'vehicleType'],
		defaultFilters: {},
	},
	// Each list (all/on-route/available/unavailable) declares
	// `defaultSortId: 'vehicle-name'`, so the sort resolver expects a
	// matching entry here. Without `tableSorts` the resolver logs
	// "defaultSortId 'vehicle-name' did not resolve to any sort fields"
	// on every mount and falls back to whatever the first column happens
	// to provide. Define the explicit sort def the lists reference, plus
	// a couple of common alternates so the "Sort by" picker is useful.
	tableSorts: [
		{
			id: 'vehicle-name',
			name: 'Name (A-Z)',
			fields: [{ direction: 'ASC', fieldName: 'name', objectTable: 'vehicle' }],
			description: 'Sort vehicles alphabetically by name',
		},
		{
			id: 'vehicle-name-desc',
			name: 'Name (Z-A)',
			fields: [
				{ direction: 'DESC', fieldName: 'name', objectTable: 'vehicle' },
			],
			description: 'Sort vehicles reverse-alphabetically by name',
		},
		{
			id: 'status-asc',
			name: 'Status (A-Z)',
			fields: [
				{ direction: 'ASC', fieldName: 'status', objectTable: 'vehicle' },
				{ direction: 'ASC', fieldName: 'name', objectTable: 'vehicle' },
			],
			description: 'Group vehicles by status, then by name',
		},
		{
			id: 'capacity-desc',
			name: 'Capacity (Largest First)',
			fields: [
				{
					direction: 'DESC',
					fieldName: 'volumeCapacity',
					objectTable: 'vehicle',
				},
			],
			description: 'Sort vehicles by volume capacity, largest first',
		},
	],
	objects: [
		{
			baseUrl: '/distribution/vehicles/:id',
			objectLabel: 'Vehicle',
			objectTable: 'vehicle',
			selectedFields: [
				{
					fieldName: '_id',
					fieldLabel: 'ID',
				},
				{
					fieldName: 'id',
					fieldLabel: 'ID',
				},
				{
					fieldName: 'name',
					fieldLabel: 'Name',
				},
				{
					fieldName: 'type',
					fieldLabel: 'Type',
				},
				{
					fieldName: 'licensePlate',
					fieldLabel: 'License Plate',
				},
				{
					fieldName: 'volumeCapacity',
					fieldLabel: 'Volume Capacity',
				},
				{
					fieldName: 'status',
					fieldLabel: 'Status',
				},
				{
					fieldName: 'assignedRoutesCount',
					fieldLabel: 'Assigned Routes',
				},
				{
					fieldName: 'createdDate',
					fieldLabel: 'Created Date',
				},
				{
					fieldName: 'modifiedDate',
					fieldLabel: 'Modified Date',
				},
			],
		},
	],
};
